import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99999,
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.accent.main,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  text: {
    padding: 30,
    fontSize: 16,
    maxWidth: 600,
    lineHeight: '18px',
    textAlign: 'center',
    color: theme.palette.white,
  },
})

const ScreenSizeMessage = ({ classes }) => (
  <div className={classes.root}>
    <Typography className={classes.text}>
      Sorry this dashboard is made to be viewed at a larger resolution, if you
      are on an tablet, please rotate to Landscape
    </Typography>
  </div>
)

ScreenSizeMessage.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(ScreenSizeMessage)



// WEBPACK FOOTER //
// ./src/components/atoms/ScreenSizeMessage.js